import * as React from 'react';
import IHeader from './IHeader';
import { classNames } from '@features/utils/reactFunctions';

import * as style from './HeaderStyle.module.scss'

const Header: React.SFC<IHeader> = (props) => {

  const inlineStyle = {
    padding: props.padding ? props.padding.replace(/ /g, 'px ').concat('px') : 'initial',
  } as React.CSSProperties;

  return (
    <div className={classNames(style.header, props.className)} style={inlineStyle}>
      {props.children}
    </div>
  );
};

export default Header;
